module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_6.7e5ac80a.png";